import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from 'styled-components';
import { Box, palette, themeMode } from '@landr/maestro';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var Handle = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    position: absolute;\n    cursor: ", ";\n    ", ";\n    ", ";\n"])), function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled ? palette('neutral.400') : palette('primary.500');
}, function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return isDisabled ? 'auto' : 'pointer';
}, function (_ref3) {
  var radius = _ref3.radius;
  return "\n        width: ".concat(radius * 2, "px;\n        height: ").concat(radius * 2, "px;\n        border-radius: ").concat(radius * 2, "px;\n        top: ").concat(-radius, "px;\n        left: ").concat(-radius, "px;\n    ");
}, function (_ref4) {
  var isDisabled = _ref4.isDisabled;
  return isDisabled && "pointer-events: none;";
});
var Draggable = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    transform: ", ";\n    position: absolute;\n"])), function (_ref5) {
  var position = _ref5.position,
      radius = _ref5.radius;
  return "translateX(".concat(position - radius / 2, "px)");
});
var Rail = styled(Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 2px;\n    background-color: ", ";\n"])), function (_ref6) {
  var isDisabled = _ref6.isDisabled;
  return isDisabled ? palette('neutral.400') : themeMode({
    light: palette('neutral.300'),
    dark: palette('neutral.600')
  });
});
var Root = styled(Box)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n"])));
export { Draggable, Handle, Rail, Root };